import Auth from "./Backend/Controllers/Auth";
import PurchaserAuth from "./Backend/Controllers/PurchaserAuth";

export default class Authenticate
{
	constructor(securityGroup)
	{
		this.authBackend = securityGroup.includes("purchaser") ? new PurchaserAuth("T3mp0r4ry") : new Auth("T3mp0r4ry");
	}

	login(user, pass,AUTHENTICATOR)
	{
		return new Promise((resolve, reject) =>
		{
			const creds = {username: user, password: pass};

			// if (newPass)
			// 	creds.newPassword = newPass;
             if(AUTHENTICATOR){
              creds.mfaType = AUTHENTICATOR
			 }
			this.authBackend.login(creds, (data) =>
			{
				if (data.errorCode)
				{
					if (data.errorCode === "CONFLICT")
					{	
						resolve({forceResetPassword: true});
					}
					reject(data.errorMessage);
				}
				else
					resolve(data);
			});
		});
	}

	forcePasswordChange(session, user, newPass)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.setNewPassword(session, user, newPass, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve(data);
			});
		});
	}

	validateMFACode(user, password, code)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.validateMFACode(user, password, code, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve(data);
			});
		});
	}

	requestMFACode(user, pwd, code)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.requestMFACode(user, pwd, code, (data) =>
			{
				if (data.errorCode && data.errorCode !== "NUMBER_NOT_VERIFIED")
					reject(data.errorMessage);
				else
					resolve(data);
			});
		});
	}

	getPhoneNoVerificationCodeFromCognito(username)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.getPhoneNoVerificationCodeFromCognito(username, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve(data);
			});
		});
	}

	verifyPhoneNoVerificationResult(otp, username)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.verifyPhoneNoVerificationResult(otp, username, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve(data);
			});
		});
	}

	requestPhoneVerification(accessToken)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.requestPhoneVerification(accessToken, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve("ok");
			});
		});
	}

	verifyPhone(accessToken, user, code)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.verifyPhone(accessToken, code, user, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve("ok");
			});
		});
	}

	forgotPassword(email)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.forgotPassword(email, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve("ok");
			});
		});
	}

	confirmForgotPassword(code, email, newPass)
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.confirmForgotPassword(code, email, newPass, (data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve("ok");
			});
		});
	}

	getSourceId()
	{
		return new Promise((resolve, reject) =>
		{
			this.authBackend.getSourceId((data) =>
			{
				if (data.errorCode)
					reject(data.errorMessage);
				else
					resolve("ok");
			});
		});
	}
}